// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lineStack > * {
    align-self: center;
}

.seriText {
    width: 100%;
}

.languageSelect {
    width: 240px;
}

.languageText {
    width: 240px;
    margin: 0px 5px;
}

.closeButton {
    align-self: flex-end;
}

/*.DeleteButton {
    align-self: center;
    cursor: pointer
}

    .DeleteButton:hover {
        color: red;
    }*/
`, "",{"version":3,"sources":["webpack://./src/app/components/controls/translationtextbox/translation.textbox.dialog.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;;;;;;MAOM","sourcesContent":[".lineStack > * {\n    align-self: center;\n}\n\n.seriText {\n    width: 100%;\n}\n\n.languageSelect {\n    width: 240px;\n}\n\n.languageText {\n    width: 240px;\n    margin: 0px 5px;\n}\n\n.closeButton {\n    align-self: flex-end;\n}\n\n/*.DeleteButton {\n    align-self: center;\n    cursor: pointer\n}\n\n    .DeleteButton:hover {\n        color: red;\n    }*/\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
